module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin": "10px 0",
      "font-size": "14px"
    }
  }, [_vm._v("请选中您需要的标签后搜索")]), _vm._v(" "), _c('div', {
    staticClass: "label-wrap"
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.labelValue),
      callback: function($$v) {
        _vm.labelValue = $$v
      },
      expression: "labelValue"
    }
  }, [_vm._l((_vm.labelOrigin), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('div', {
      staticClass: "label-box"
    }, [_c('span', {
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v(_vm._s(item.labelName))]), _vm._v("：\n              "), _vm._l((item.labelVos), function(itm, idx) {
      return _c('span', {
        key: idx
      }, [(itm.tips) ? [_c('el-popover', {
        attrs: {
          "trigger": "hover",
          "placement": "top",
          "popper-class": "label-popover"
        }
      }, [_c('div', {
        staticClass: "popover-center"
      }, [_vm._v("\n                      " + _vm._s(itm.tips) + "\n                    ")]), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "reference"
        },
        slot: "reference"
      }, [_c('el-checkbox', {
        attrs: {
          "label": itm.labelName,
          "border": ""
        }
      }, [_vm._v(_vm._s(itm.labelName))])], 1)])] : [_c('el-checkbox', {
        attrs: {
          "label": itm.labelName,
          "border": ""
        }
      }, [_vm._v(_vm._s(itm.labelName))])]], 2)
    })], 2)])
  }), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "10px 0",
      "padding-right": "30px",
      "box-sizing": "border-box"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726"
    },
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.init
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10px",
      "display": "inline-block"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "border-color": "#ffa726",
      "color": "#ffa726"
    },
    attrs: {
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)])], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 0 10px",
      "font-size": "12px",
      "color": "#bca365"
    }
  }, [_vm._v("\n        温馨提示：商品标签仅作参考，实际以货架生效为准\n        "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#ffa726"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_c('router-link', {
    staticStyle: {
      "color": "#ffa726",
      "text-decoration": "underline"
    },
    attrs: {
      "tag": "a",
      "to": {
        name: 'DownloadList'
      }
    }
  }, [_vm._v("\n              下载列表\n            ")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10px",
      "display": "inline-block"
    }
  }), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "将本页所有商品添加报价至报价篮子，前往报价篮子可以批量导出商品报价",
      "placement": "top",
      "popper-class": "custom-width"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.getPriceAll
    }
  }, [_vm._v("批量获取报价")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10px",
      "display": "inline-block"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10px",
      "display": "inline-block"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.addNewShelvesAll
    }
  }, [_vm._v("批量加入货架")])], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasGoods),
      expression: "hasGoods"
    }],
    staticClass: "table-static th-eee",
    staticStyle: {
      "border-top": "1px solid #EBEEF5"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "fit": "",
      "id": "table-scroll"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "商品信息",
      "align": "center",
      "min-width": "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "goods-info"
        }, [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top",
            "popper-class": "table-popover"
          }
        }, [_c('div', {
          staticClass: "table-popover"
        }, [_c('img', {
          staticStyle: {
            "width": "240px",
            "height": "240px"
          },
          attrs: {
            "src": scope.row.goodsPicture
          },
          on: {
            "error": function($event) {
              return _vm.error(1)
            }
          }
        }), _vm._v(" "), _c('table', {
          attrs: {
            "border": "0",
            "cellspacing": "10"
          }
        }, [_c('tr', {
          staticStyle: {
            "color": "#666"
          }
        }, [_c('th', {
          attrs: {
            "width": "160px"
          }
        }, [_vm._v("SKU")]), _vm._v(" "), _c('th', [_vm._v("带票结算价（+运费）")]), _vm._v(" "), _c('th', [_vm._v("库存")])]), _vm._v(" "), _vm._l((scope.row.products), function(item, index) {
          return (index < 7) ? _c('tr', {
            key: index,
            staticStyle: {
              "color": "#333"
            }
          }, [
            [_c('td', [_c('div', {
              staticStyle: {
                "width": "150px",
                "overflow": "hidden",
                "text-overflow": "ellipsis",
                "white-space": "nowrap"
              }
            }, [_vm._v(_vm._s(item.specName))])]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(item.settlementPrice / 100) + "（+" + _vm._s(item.freight / 100) + "）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.inventoryNum))])]
          ], 2) : _vm._e()
        })], 2)]), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('router-link', {
          attrs: {
            "tag": "a",
            "target": "_blank",
            "to": {
              name: 'Detail',
              query: {
                goodsId: scope.row.goodsId
              }
            }
          }
        }, [_c('div', {
          staticClass: "goods-img"
        }, [_c('img', {
          attrs: {
            "src": scope.row.goodsImage
          },
          on: {
            "error": function($event) {
              return _vm.error(1)
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "category-cover-image",
          class: {
            'a': scope.row.hasTax == 1
          }
        })])])], 1)]), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin-left": "15px",
            "text-align": "left"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.goodsName,
            "placement": "top"
          }
        }, [_c('div', {
          staticStyle: {
            "font-size": "14px",
            "text-align": "left",
            "color": "#333",
            "display": "-webkit-box",
            "-webkit-box-orient": "vertical",
            "-webkit-line-clamp": "2",
            "overflow": "hidden"
          }
        }, [_vm._v(_vm._s(scope.row.goodsName))])]), _vm._v(" "), _c('div', {
          staticStyle: {
            "font-size": "14px",
            "margin": "5px 0",
            "text-align": "left",
            "color": "#666"
          }
        }, [_vm._v("品牌：" + _vm._s(scope.row.brandName))]), _vm._v(" "), (scope.row.supplyChannel > 1) ? _c('div', {
          staticClass: "type-icon",
          staticStyle: {
            "display": "inline-block",
            "line-height": "22px",
            "text-align": "center"
          }
        }, [_vm._v("社群集采")]) : _vm._e(), _vm._v(" "), (scope.row.supplyChannel == 1) ? _c('div', {
          staticClass: "type-icon",
          staticStyle: {
            "display": "inline-block",
            "line-height": "22px",
            "text-align": "center"
          }
        }, [_vm._v("一件代发")]) : _vm._e(), _vm._v(" "), (scope.row.isSelf == 1) ? _c('div', {
          staticClass: "type-icon",
          staticStyle: {
            "background-color": "rgb(231,249,235)",
            "color": "rgb(88,191,106)",
            "margin-top": "10px",
            "display": "inline-block",
            "line-height": "22px",
            "text-align": "center"
          }
        }, [_vm._v("自产自销")]) : _vm._e()], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "标签",
      "align": "center",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.labelArr), function(item, index) {
          return _c('span', {
            key: index,
            staticClass: "table-label-tip"
          }, [_vm._v(_vm._s(item))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "建议零售价",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              ￥" + _vm._s(scope.row.salePrice / 100) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "结算价",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "color": "#ffa726"
          }
        }, [_vm._v("￥" + _vm._s(scope.row.originSettlementPrice / 100))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "毛利",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              ￥" + _vm._s((scope.row.salePrice - scope.row.settlementPrice).toFixed(2) / 100) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "毛利率",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s((
          ((scope.row.salePrice - scope.row.settlementPrice) /
            scope.row.salePrice) *
          100
        ).toFixed(2) + "%") + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.shelvesStatus == 0) ? _c('div', {
          staticClass: "category-goods-add-default",
          staticStyle: {
            "margin-top": "0",
            "height": "40px",
            "background-color": "#ffa726",
            "border-color": "#ffa726",
            "color": "#fff"
          },
          on: {
            "click": function($event) {
              return _vm.addNewShelves(scope.row)
            }
          }
        }, [_vm._v("加入货架")]) : _vm._e(), _vm._v(" "), (scope.row.shelvesStatus == 1) ? _c('div', {
          staticClass: "category-goods-add-default yishangjia",
          staticStyle: {
            "margin-top": "0",
            "height": "40px"
          }
        }, [_vm._v("已加入货架")]) : _vm._e(), _vm._v(" "), (true) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "添加商品报价至报价篮子，可以批量导出商品报价",
            "placement": "top",
            "popper-class": "custom-width"
          }
        }, [_c('div', {
          staticClass: "get-price-label",
          on: {
            "click": function($event) {
              return _vm.getPrice(scope.row)
            }
          }
        }, [_vm._v("获取报价")])]) : _vm._e(), _vm._v(" "), (false) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "该商品已添加至“报价篮子”，可以前往“报价篮子”导出报价！",
            "placement": "top"
          }
        }, [_c('div', {
          staticClass: "get-price-label yet"
        }, [_vm._v("已添加报价")])]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasGoods),
      expression: "hasGoods"
    }],
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageNum,
      "total": _vm.pageTotal,
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.pageNum = $event
      },
      "update:current-page": function($event) {
        _vm.pageNum = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasGoods),
      expression: "!hasGoods"
    }],
    staticClass: "category-goods-wrap-no"
  }, [_c('div', {
    staticClass: "category-goods-wrap-tip"
  }, [_vm._v("没有找到相关商品...")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出提示",
      "visible": _vm.dialogVisible,
      "width": "600px",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("导出任务正在生成，请前往【下载列表】中下载您已导出的信息")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("好的，我知道了")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible2,
      "width": "600px",
      "before-close": _vm.handleClose2
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("成功添加商品到“报价篮子”，可以前往“报价篮子”批量导出商品报价！")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "category-goods-add-default",
    staticStyle: {
      "width": "200px",
      "margin": "0 auto"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible2 = false
      }
    }
  }, [_vm._v("我知道了")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08cde076","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CategoryLabel.vue
// module id = 512
// module chunks = 1